// ©2024 Austin App House. All rights reserved.
// Annoying modal window. Use if banking information is required for contractor.
import React from 'react';
import {connect} from 'react-redux';
import {
  MDBBtn, MDBCol, MDBContainer, MDBModal, MDBModalBody, MDBRow,
} from 'mdbreact';
import { toggleModal } from '../../storage/actions/modalsActions';

const SetUpBankInfoForContractor = (
  {
    modalState,
    toggleModal,
  },
) => {
  const closeModal = () => toggleModal(!modalState.isOpen, 'setUpBankInfoForContractor');
  const submitApprove = () => {
    toggleModal(true, 'addBankInfoForContractor');
  };
  return (
        <div className="modal_block dashboard-modal dashboard-modal--centered showed">
          <div className="modal_container">
            <h6 className={"page_title"}>You've not yet set up your banking information.</h6>
            <label>
              <span className="dashboard-modal-title">
                You will need to set up your banking information before you can be paid
              </span>
            </label><br/>
              <div className={'modal_footer'}>
                  <button className="standard_btn lightest_btn" onClick={closeModal}>Cancel</button>
                  <button color="success" className={'standard_btn lightest_btn'} onClick={submitApprove}>Set Up Now</button>
              </div>
          </div>

        </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
};

const mapStateToProps = state => ({
  modalState: state.modalState.setUpBankInfoForContractor,
  profile: state.profile,
});

export default connect(mapStateToProps, mapDispatchToProps)(SetUpBankInfoForContractor);
